import styles from '../Product.module.scss';
import cx from 'classnames';
import { ProductCardBottomIconsWrapperProps } from '../types';

export const ProductCardBottomIconsWrapper = ({
  className,
  children
}: ProductCardBottomIconsWrapperProps) => {
  return (
    <div
      className={cx(
        styles['product-comparison__card-bottom-icons'],
        'd-flex mt-2',
        className
      )}
    >
      {children}
    </div>
  );
};

export default ProductCardBottomIconsWrapper;
